import React, { useEffect } from 'react';
import { Plus, X, FileText, Circle } from 'lucide-react';
import useEditorStore from '../store/useEditorStore';
import { newTab, switchTab, closeTab, ensureInitialTab } from '../store/tabsManager';
import { toast } from 'sonner';

export default function TabsBar() {
  const tabs = useEditorStore((s) => s.tabs);
  const activeTabId = useEditorStore((s) => s.activeTabId);

  useEffect(() => { ensureInitialTab(); }, []);

  return (
    <div className="tabs-bar" data-testid="tabs-bar">
      <div className="tabs-scroll">
        {tabs.map((t) => {
          const isActive = t.tabId === activeTabId;
          const label = t.meta?.name || 'Sans titre';
          return (
            <div
              key={t.tabId}
              className={`project-tab ${isActive ? 'active' : ''}`}
              onClick={() => switchTab(t.tabId)}
              data-testid={`tab-${t.tabId}`}
              title={t.meta?.client ? `${label} — ${t.meta.client}` : label}
            >
              <FileText size={12} className="tab-icon" />
              <span className="tab-label">{label}</span>
              {t.dirty && <Circle size={6} className="tab-dirty" />}
              <button
                className="tab-close"
                onClick={(e) => {
                  e.stopPropagation();
                  if (tabs.length === 1) {
                    toast.info('Au moins un onglet doit rester ouvert');
                    return;
                  }
                  if (t.dirty) {
                    if (!window.confirm(`Fermer "${label}" sans enregistrer ?`)) return;
                  }
                  closeTab(t.tabId);
                }}
                title="Fermer"
                aria-label="Fermer l'onglet"
                data-testid={`tab-close-${t.tabId}`}
              >
                <X size={11} />
              </button>
            </div>
          );
        })}
      </div>
      <button
        className="tab-new"
        onClick={() => {
          newTab('Nouveau projet');
          toast.success('Nouvel onglet créé');
        }}
        title="Nouveau projet"
        data-testid="tab-new"
      >
        <Plus size={14} />
      </button>
    </div>
  );
}
